﻿window.VoterFly.tagHelpers = {
    intervalDate: function (wrapper) {

        let dateComponents = {
            date : null,
            hour: null,
            minute: null,
            ampm: null,
            hasAnyValue: function () {
                if (this.date ||
                    this.hour ||
                    this.minute ||
                    this.ampm) {
                    return true;
                }
                return false;
            },

            hasAllValues: function () {
                if (dateComponents.date &&
                    dateComponents.hour &&
                    dateComponents.minute &&
                    dateComponents.ampm) {
                    return true;
                } else {
                    return false;
                }
            }
        };

        const $wrapper = $(wrapper);
        const $dateInput = $wrapper.find('input[type=date]');
        const $hourInput = $wrapper.find('select.hour');
        const $minuteInput = $wrapper.find('select.minute');
        const $amPmInput = $wrapper.find('select.ampm');
        const $clearLink = $wrapper.find('a.action-clear');
        const $hiddenInput = $wrapper.find('input[type=hidden]');

        setupElementValidation($dateInput);
        setupElementValidation($hourInput);
        setupElementValidation($minuteInput);
        setupElementValidation($amPmInput);

        function setupElementValidation($input) {
            $input.rules("add", {
                // required: true,
                required: {
                    depends: function (element) {
                        return dateComponents.hasAnyValue();
                    }
                }
            });
        }

        const rawValue = $hiddenInput.val();

        if (rawValue) {
            const date = new Date(rawValue);

            dateComponents.date = date.getFullYear().toString() + '-' +
                (date.getMonth() + 1).toString().padStart(2, '0') + '-' +
                date.getDate().toString().toString().padStart(2, '0');

            if (date.getHours() >= 12) {
                dateComponents.hour = (date.getHours() - 12).toString();
                dateComponents.ampm = "PM";
            } else {
                dateComponents.hour = date.getHours().toString();
                dateComponents.ampm = "AM";
            }
            
            dateComponents.minute = date.getMinutes().toString();

            updateHiddenInput();
            updateUiForState();
        }

        $clearLink.click(function () {
            dateComponents.date = null;
            dateComponents.hour = null;
            dateComponents.minute = null;
            dateComponents.ampm = null;
            updateHiddenInput();
            updateUiForState();
        });

        $dateInput.change(function (event) {

            dateComponents.date = $(this).val();

            updateHiddenInput();
        });

        $wrapper.find('select').change(function (event) {

            $select = $(this);

            if ($select.hasClass('hour')) {
                dateComponents.hour = $select.val();
            } else if ($select.hasClass('minute')) {
                dateComponents.minute = $select.val();
            } else if ($select.hasClass('ampm')) {
                dateComponents.ampm = $select.val();
            }

            updateHiddenInput();
        });

        function updateHiddenInput() {
            if (dateComponents.hasAnyValue()) {
                if (!dateComponents.hasAllValues()) {
                    // Invalid
                } else {
                    let hour = dateComponents.hour;

                    if (dateComponents.ampm == "PM") {
                        hour = Number.parseInt(hour, 10) + 12;
                        hour = hour.toString().padStart(2, 0);
                    }

                    hour = hour.toString().padStart(2, '0');
                    minute = dateComponents.minute.toString().padStart(2, '0');

                    const dateString = `${dateComponents.date}T${hour}:${minute}:00`;

                    $hiddenInput.val(dateString);
                }
            } else {
                $hiddenInput.val('');
            }
        }

        function updateUiForState() {
            if (dateComponents.hasAllValues()) {
                $dateInput.val(dateComponents.date);
                $hourInput.val(dateComponents.hour);
                $minuteInput.val(dateComponents.minute);
                $amPmInput.val(dateComponents.ampm);
            } else {
                $dateInput.val('');
                $hourInput.val('');
                $minuteInput.val('');
                $amPmInput.val('');
            }
        }
        
    }
};